import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className: string,
};

const Program = ({
  className,
  stroke,
  width,
  height,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <g
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        transform="matrix(.26458 0 0 .26458 -17.508 9.425)"
      >
        <path
          strokeLinejoin="round"
          strokeWidth="2"
          d="M98.363-25.34h3.331V4.326h-23.04v-29.66h2.9"
        />
        <path
          strokeLinejoin="round"
          strokeWidth="2"
          d="M83.274-15.122h13.517"
        />
        <path
          strokeLinejoin="miter"
          strokeWidth="2"
          d="M83.27-10.17h13.521"
        />
        <path
          strokeLinejoin="miter"
          strokeWidth="2"
          d="M83.27-5.178h13.521"
        />
        <path
          strokeLinejoin="miter"
          strokeWidth="2"
          d="M83.27-.175h13.521"
        />
        <path
          strokeLinejoin="round"
          strokeWidth="2"
          d="M93.89-27.571h-7.795v1.756h-1.906v4.553h11.51v-4.549h-1.804z"
        />
        <circle
          cx="89.944"
          cy="-24.779"
          r="0.516"
          fillOpacity="1"
          strokeLinejoin="round"
          strokeWidth="1.1"
          opacity="0.999"
        />
      </g>
    </g>
  </svg>
);

Program.defaultProps = {
  stroke: '#1a1818',
  width: '48',
  height: '48',
};

export default Program;
